import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";
import "./GridPresetSidebar.scss";
import cn from "classnames";

export enum GridPresetSidebarMargins {
  PublicationPage = 1,
}

interface GridRowProps {
  children: ReactNode | ReactNode[];
  hideForMobileAndTablet?: boolean;
  rowSpan?: number;
  margins?: GridPresetSidebarMargins;
  gridRow?: undefined | 2;
}

const GridPresetSidebar = ({
  children,
  hideForMobileAndTablet,
  rowSpan,
  margins,
  gridRow,
}: GridRowProps) => (
  <GridCell
    startColsDesktop={9}
    spanColsDesktop={4}
    startColsTablet={1}
    spanColsTablet={6}
    startColsMobile={1}
    spanColsMobile={6}
    rowSpan={rowSpan}
    gridRow={gridRow}
  >
    <div
      className={cn("grid-preset-sidebar-norad", {
        "grid-preset-sidebar-norad--hide-for-mobile-and-tablet":
          hideForMobileAndTablet,
        "grid-preset-sidebar-norad--publication-page-margins":
          margins === GridPresetSidebarMargins.PublicationPage,
      })}
    >
      {children}
    </div>
  </GridCell>
);

export default GridPresetSidebar;
